import { Component, OnInit, OnDestroy, AfterViewInit, ElementRef, ViewChild, Input, OnChanges, Output, EventEmitter, SimpleChanges } from '@angular/core';
import MetisMenu from 'metismenujs';
import { EventService } from '../../core/services/event.service';
import { Router, NavigationEnd } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { MENU } from '../sidebar/menu';
import { MenuItem } from './menu.model';
import { TranslateService } from '@ngx-translate/core';
import { MiddlwareService } from 'src/app/core/services/middleware.service';
import { WebsocketService } from 'src/app/core/services/websocket.service';
import { environment } from 'src/environments/environment';
import { PermissionLevel } from 'src/app/core/services/constants';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @ViewChild('componentRef') scrollRef;
  @ViewChild('sideMenu') sideMenu: ElementRef;
  @Input() isCondensed = false;
  @Input() isHover = false;
  @Input() isMain = true;
  @Output() mobileMenuHover = new EventEmitter();

  adminSubscription: any;
  menu: any;
  data: any;
  menuItems = [];

  showAdmin = false;
  isTransitioning = false;
  hovering = false;

  expired = false;

  constructor(
    private mdw: MiddlwareService,
    private ws: WebsocketService,
    private eventService: EventService,
    private router: Router,
    public translate: TranslateService,
    private title: Title,
    private http: HttpClient) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._activateMenuDropdown();
        this._scrollElement();
        this.setClarityPage(event.urlAfterRedirects);
      }
    });
  }
  private clarityRouteMap = new Map<string, { parent?: string; label: string }>();


  ngOnInit() {
    this.showAdmin = environment.admin_page;
    this.initialize();
    this._scrollElement();
    // this.adminSubscription = this.mdw.showRootAdminContainer$.subscribe((data)=>{
    //   this.showAdmin = data;
    //   this.filter();
    // })
  }


// filterMenuByPermissions(menuItems: MenuItem[]): MenuItem[] {

//   const storedPermissions = this.mdw.getPermissions(localStorage.getItem("id"));
//   console.log("storedPermissions", storedPermissions);

//   return menuItems.reduce((acc, item) => {
//     if (item.subItems) {
//         const filteredSubItems = item.subItems.filter(subItem => {
//         const bitOffset = subItem.bitOffset;
//         let hasPerm: boolean
//          if (bitOffset){
//           console.log(" #1");
//             hasPerm = this.mdw.hasPermission(Number(bitOffset), PermissionLevel.Read);
//          }else {
//           console.log(" #2");
//             hasPerm = false
//          }

//         console.log(`Label: ${subItem.label}, BitOffset: ${bitOffset}, hasPermission: ${hasPerm}`);
//         return hasPerm;
//       });


//       console.log(`Parent: ${item.id}, filteredSubItems: ${filteredSubItems.length}`);
//       if (filteredSubItems.length > 0) {
//         acc.push({ ...item, subItems: filteredSubItems });
//       }
//     } else if (!item.isTitle && item.link) {
//       const bitOffset = item.bitOffset;
//       const hasPerm = bitOffset !== undefined && this.mdw.hasPermission(Number(bitOffset), PermissionLevel.Read);
//       // console.log(`Single Label: ${item.id}, BitOffset: ${bitOffset}, hasPermission: ${hasPerm}`);
//       if (hasPerm) {
//         acc.push(item);
//       }
//     } else if (item.isTitle) {
//       const nextItemsIndex = menuItems.indexOf(item) + 1;
//       const nextItems = menuItems.slice(nextItemsIndex);
//       console.log("nextItems", nextItems);
//       const hasValidItems = nextItems.some(nextItem => {
//       const bitOffset = nextItem.bitOffset;
//        let hasPerm: boolean
//          if (bitOffset){
//           console.log(" #3");
//             hasPerm = this.mdw.hasPermission(Number(bitOffset), PermissionLevel.Read);
//          }else {
//           console.log(" #4");
//             hasPerm = false
//          }
//         console.log(`Label: ${nextItem.label}, BitOffset: ${bitOffset}, hasPermission: ${hasPerm}`);
//         return hasPerm;
//       });

//       // console.log(`Title: ${item.label}, hasValidItems: ${hasValidItems}`);

//       if (hasValidItems) {
//         acc.push(item);
//       }
//     }
//     return acc;
//   }, []);
// }


filterMenuByPermissions(menuItems: MenuItem[]): MenuItem[] {
  const storedPermissions = this.mdw.getPermissions(localStorage.getItem("id"));
  const filteredMenu: MenuItem[] = [];
  let i = 0;

  while (i < menuItems.length) {
    const item = menuItems[i];
    // If it's a title, start a new section
    if (item.isTitle) {
      const sectionItems: MenuItem[] = [];
      const titleItem = item;
      i++;
      // Gather items under this title until the next title
      while (i < menuItems.length && !menuItems[i].isTitle) {
        const sectionItem = menuItems[i];
        let includeItem = false;
        if (sectionItem.subItems) {
          const filteredSubItems = sectionItem.subItems.filter(subItem => {
            if (subItem.bitOffset !== undefined) {
              return this.mdw.hasPermission(Number(subItem.bitOffset), PermissionLevel.Read);
            }
            return false;
          });

          if (filteredSubItems.length > 0) {
            includeItem = true;
            sectionItems.push({ ...sectionItem, subItems: filteredSubItems });
          }
        } else if (!sectionItem.isTitle && sectionItem.link && sectionItem.bitOffset !== undefined) {
          if (this.mdw.hasPermission(Number(sectionItem.bitOffset), PermissionLevel.Read)) {
            includeItem = true;
            sectionItems.push(sectionItem);
          }
        }

        i++;
      }
      // Only include the title if there is at least one item in its section
      if (sectionItems.length > 0) {
        filteredMenu.push(titleItem, ...sectionItems);
      }
    } else {
      // If the item is outside any title group (very rare), evaluate it directly
      if (item.bitOffset !== undefined && this.mdw.hasPermission(Number(item.bitOffset), PermissionLevel.Read)) {
        filteredMenu.push(item);
      }
      i++;
    }
  }

  return filteredMenu;
}


filter() {
  let tempMenuItems = [];

  if (this.showAdmin && this.isMain) {
    tempMenuItems = MENU;
  } else if (this.showAdmin && !this.isMain) {
    tempMenuItems = MENU.filter(menu => !menu.isMain);
  } else if (!this.showAdmin && this.isMain) {
    tempMenuItems = MENU.filter(menu => menu.label !== 'Admin' && menu.label !== 'Bullk Upload' );
  } else if (!this.showAdmin && !this.isMain) {
    tempMenuItems = MENU.filter(menu => menu.label !== 'Admin' && menu.label !== 'Bullk Upload' && !menu.isMain);
  }

  this.menuItems = this.filterMenuByPermissions(tempMenuItems);
  this.buildClarityRouteMap(this.menuItems);
}

  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
    this.notifyClaritySidebarReady();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isMain'] && !changes['isMain'].firstChange) {
      this.filter();
      // Wait for the view to update with the new menu items
      setTimeout(() => {
        // Dispose the old MetisMenu instance if it exists
        if (this.menu) {
          this.menu.dispose();
        }
        // Reinitialize MetisMenu with the updated sideMenu
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
        // Optionally, re-run activation logic if needed
        this._activateMenuDropdown();
      });

    this.notifyClaritySidebarReady(1000);

    }

    if (changes['isCondensed'] || changes['isHover']) {
      if ((!this.isCondensed && this.sideMenu) || this.isHover) {
        this.menu.dispose();
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      } else if (this.menu) {
        this.menu.dispose();
      }
    }
  }


  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
        if(this.scrollRef && this.scrollRef.SimpleBar !== null)
          this.scrollRef.SimpleBar.getScrollElement().scrollTop =
            currentPosition + 300;
      }
    }, 300);
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }

  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = MENU;
    this.filter();
  }

  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  hoverSideMenu(event){
    if((this.isCondensed || this.hovering) && !this.isTransitioning){
      this.hovering = !this.hovering;
      this.isTransitioning = true;
      this.hoverMobileMenu(event);
      setTimeout(() => {
        this.isTransitioning = false;
      }, 450);
    }
  }

  hoverMobileMenu(event: any) {
    event.preventDefault();
    this.mobileMenuHover.emit();
    this.mdw._layoutRefreshContainer.next(true);
  }

  private buildClarityRouteMap(menuItems: MenuItem[]) {
  this.clarityRouteMap.clear();

  menuItems.forEach(item => {
    if (item.subItems?.length) {
      item.subItems.forEach(sub => {
        if (sub.link) {
          this.clarityRouteMap.set(sub.link, {
            parent: item.label,
            label: sub.label,
          });
        }
      });
    } else if (item.link) {
      this.clarityRouteMap.set(item.link, {
        label: item.label,
      });
    }
  });
}

private setClarityPage(url: string) {
  if (!window['clarity']) return;

  // Normalize URL (remove params, fragments)
  const cleanUrl = url.split('?')[0].split('#')[0];

  const menu = this.clarityRouteMap.get(cleanUrl);
  if (!menu) return;

  const pageName = menu.parent
    ? `${menu.parent} > ${menu.label}`
    : menu.label;

  window['clarity']('set', 'page', pageName);
  window['clarity']('set', 'section', menu.parent || 'root');
  this.title.setTitle(pageName + ' | nandbox Admin');
}


notifyClaritySidebarReady(delay = 800) {
  setTimeout(() => {
    if ((window as any).clarity) {
      (window as any).clarity('set', 'ui', 'sidebar-ready');
    }
  }, delay);
}


  ngOnDestroy(): void {
    if(this.adminSubscription){
      this.adminSubscription.unsubscribe();
    }
  }
}
